import { FloatingFormItem } from '@/components/_common';
import { Informative } from '@/core/domain/notification/Informative/Informative.types';
import { Card, Col, Input, Modal, ModalProps, Row } from 'antd';
import moment from 'moment';
import React from 'react';

// import { Container } from './styles';

type Props = Omit<ModalProps, 'onCancel'> & {
  informative?: Informative;
  onCancel: () => void;
};

const ViewInformativeModal: React.FC<Props> = ({
  open,
  onCancel,
  informative,
}) => {
  return (
    <Modal title="Detalhe do Informativo" open={open} onCancel={onCancel}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card style={{ textAlign: 'center' }}>
            {`${informative?.employeeName} -
         ${moment(informative?.informationDate).format('DD/MM/YYYY')}`}
          </Card>
        </Col>
        <Col span={24}>
          <FloatingFormItem>
            <Input.TextArea rows={3} disabled value={informative?.message} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Modal>
  );
};

export default ViewInformativeModal;
